interface SpatialEntity {
  id: string;
  x: number;
  y: number;
  radius: number;
}

export class SpatialHash {
  private cellSize: number;
  private grid: Map<string, SpatialEntity[]> = new Map();

  constructor(cellSize: number = 4) {
    this.cellSize = cellSize;
  }

  private getKey(x: number, y: number): string {
    const cx = Math.floor(x / this.cellSize);
    const cy = Math.floor(y / this.cellSize);
    return `${cx},${cy}`;
  }

  insert(entity: SpatialEntity, x: number, y: number, radius: number): void {
    const minX = Math.floor((x - radius) / this.cellSize);
    const maxX = Math.floor((x + radius) / this.cellSize);
    const minY = Math.floor((y - radius) / this.cellSize);
    const maxY = Math.floor((y + radius) / this.cellSize);

    for (let cx = minX; cx <= maxX; cx++) {
      for (let cy = minY; cy <= maxY; cy++) {
        const key = `${cx},${cy}`;
        if (!this.grid.has(key)) {
          this.grid.set(key, []);
        }
        this.grid.get(key)!.push(entity);
      }
    }
  }

  query(x: number, y: number, radius: number): SpatialEntity[] {
    const result: SpatialEntity[] = [];
    const seen = new Set<string>();

    const minX = Math.floor((x - radius) / this.cellSize);
    const maxX = Math.floor((x + radius) / this.cellSize);
    const minY = Math.floor((y - radius) / this.cellSize);
    const maxY = Math.floor((y + radius) / this.cellSize);

    for (let cx = minX; cx <= maxX; cx++) {
      for (let cy = minY; cy <= maxY; cy++) {
        const key = `${cx},${cy}`;
        const cell = this.grid.get(key);
        if (cell) {
          for (const entity of cell) {
            if (!seen.has(entity.id)) {
              seen.add(entity.id);
              result.push(entity);
            }
          }
        }
      }
    }

    return result;
  }

  clear(): void {
    this.grid.clear();
  }
}